module.exports = __webpack_public_path__ + "d0d56ff8bdb244712e9e483c6a639080.png";